import React, { useContext, useEffect } from 'react'
// import { Route } from '../Models/Route';
import { nonRoutes, clientRoutes, adminRoutes } from '../Routes/Routes';
import { useNavigate } from 'react-router-dom';

import jwt from 'jwt-decode'
import { PromiseSesionContext } from '../Machines/ErrorMachine';
import { addMonitor } from '../Api/Monitor';
import { Monitor } from '../Models/Monitor';
import { useLocation } from 'react-router-dom';
import { Route } from '../Models/Route';
import { Client } from '../Models/Client';



interface Props {
    children: React.ReactNode
}

const CartGuard = ({children}:Props) => {
    const {sesion, sendSesion } = useContext(PromiseSesionContext);
    const navigate = useNavigate();

    const {cart, sendCart, cartCard, sendCartCard} = useContext(PromiseSesionContext);

    const APP_VERSION_KEY = 'appVersion';
    const CURRENT_APP_VERSION = process.env.REACT_APP_VERSION || 'desconocida';
    const location = useLocation();


    const deleteCart = () => {
        localStorage.removeItem("cart")
        localStorage.removeItem("cartCard")

        sendCart({type: "DELETE", data:{}})
        sendCartCard({type: "DELETE", data:{}})

    }

    useEffect(() => {
        const storedVersion = localStorage.getItem(APP_VERSION_KEY);
        validateUser()
        if(storedVersion !== CURRENT_APP_VERSION){
            deleteCart()
            localStorage.setItem(APP_VERSION_KEY, CURRENT_APP_VERSION);
        }
        else{
        chargeLocalCartShop()
        chargeLocalCartCardShop()
        }

    }, []);

    const generateUniqueCharacter = () => {
    // Use a high-precision timestamp to ensure uniqueness per millisecond
    const timestamp = Date.now().toString(36); 
    
    // Use a random number string
    const randomString = Math.random().toString(36).substring(2, 6);
    return `${timestamp}-${randomString}`;
    };

    const validateUser = async ()=>{
        const searchParams = new URLSearchParams(window.location.search);
        const fromValue = searchParams.get('from');

        let user:string= ""
        if(localStorage.getItem("user")){
            user=localStorage.getItem("user") || ""
        } 
        else{
            user = generateUniqueCharacter()
            localStorage.setItem("user", user)
        }
        let monitor:Monitor={
            action:`Inicio ${location.pathname} ${fromValue ? (" desde " + fromValue) : ""}`,
            user:user
        }
        await addMonitor(monitor)
    }


    useEffect(() => {
        saveLocalCartShop()
    }, [cart.context.cart, cart.value]);

    useEffect(() => {
        saveLocalCartCardShop()
    }, [cartCard.context.cart, cartCard.value]);

    const saveLocalCartShop=()=>{
        if(cart.context.cart.total!==0){
            localStorage.removeItem("cart")
            localStorage.setItem("cart", JSON.stringify(cart.context.cart))
        }
    }

    const saveLocalCartCardShop=()=>{
        if(cartCard.context.cart.total!==0){
            localStorage.removeItem("cartCard")
            localStorage.setItem("cartCard", JSON.stringify(cartCard.context.cart))
        }
    }

    const chargeLocalCartShop=()=>{
        if(localStorage.getItem("cart")){
            sendCart({type: "SET", data:{cart:JSON.parse(localStorage.getItem("cart") || "")}})
        }
    }

    const chargeLocalCartCardShop=()=>{
        if(localStorage.getItem("cartCard")){
            sendCartCard({type: "SET", data:{cart:JSON.parse(localStorage.getItem("cartCard") || "")}})
        }
    }



  return (
    <>
        {
            children 
        }
    </>
  )
}

export default CartGuard